import { useStore } from '@/store';
import { useEffect } from 'react';
import { DirtyType } from '@/types';
import XXH from 'xxhashjs';

/**
 * Watches for textContent changes (file switching) and enqueues
 * all value-bearing entries as dirty so the global entry listener
 * picks them up for recomputation. Uses a stored hash of the last
 * content so we detect genuine file changes across application
 * sessions (e.g. reopen same template with a different file).
 */
export const useActiveFile = () => {
  const textContent = useStore(({ config: c }) => c.textContent);
  const lastTextContentHash = useStore(({ config: c }) =>
    c.getLastTextContentHash(),
  );
  const bootstrapVersion = useStore((s) => s.ai.bootstrapVersion);
  const addDirtyAll = useStore(({ entries: e }) => e.addDirtyAll);
  const setLastTextContentHash = useStore(
    ({ config: c }) => c.setLastTextContentHash,
  );

  useEffect(() => {
    if (textContent === undefined) return;

    const currentHash = XXH.h32(textContent, 0).toString(16);
    if (currentHash === lastTextContentHash) return;

    setLastTextContentHash(currentHash);
    addDirtyAll(DirtyType.Template);
  }, [textContent, lastTextContentHash, addDirtyAll, setLastTextContentHash]);

  useEffect(() => {
    if (!textContent) return;
    addDirtyAll(DirtyType.Template);
  }, [bootstrapVersion, textContent, addDirtyAll]);
};
